module.exports = __webpack_public_path__ + "static/media/intro01.17a27ae9.png";